import { useEffect, useState } from "react"
import { changeDateLastTwoMonthPerDayInMonthChart, getStepsStatsLasTwoMonthsPerDay } from "redux/reducers/stepsReducer"
import moment from "moment";
import { lastSixMonths } from "resources/ParametersTypes"
import BarChartDateArrowSelector from "components/Charts/BarChartDateArrowSelector"
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerDayTotalInMonth = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString())

  const patientId = useSelector(({ patient }) => patient.id)
  const { data, status } = useSelector(({ stepsData }) => stepsData.lastTwoMonthsPerDayInMonthPatientData)
  const chartData = useSelector(({ stepsData }) => stepsData.perDayChartTotalStepsInMonth)


  const dispatch = useDispatch()

  useEffect(() => {
    if (patientId && selectedDate) {
      dispatch(getStepsStatsLasTwoMonthsPerDay(patientId, selectedDate));
    }
  }, [patientId, selectedDate, dispatch]);

  useEffect(() => {
    if (patientId && !!selectedDate && !!status) {
      dispatch(changeDateLastTwoMonthPerDayInMonthChart(selectedDate))
    }
  }, [data, dispatch, patientId, selectedDate, status])

  return (
    <BarChartDateArrowSelector
      dataToShow={chartData}
      title={Dashboard.STEPS_DAY_MONTH}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={lastSixMonths}
      maxDate={moment()}
      interval={'month'}
    />
  )
}

export default PerDayTotalInMonth
